import * as React from 'react';

class App extends React.Component {
  public render() {
    return (
      <div>
        <h1>hello</h1>
      </div>
    );
  }
}

export default App;
